import { Suspense, lazy } from 'react';
import Loader from './Loader';

// How long to wait before allowing another auto-reload (matches ChunkErrorFallback guard)
const RELOAD_KEY = 'last-chunk-error-reload';
const RELOAD_COOLDOWN_MS = 10000;

// Wraps a dynamic import factory so that if the chunk fails to load (e.g. stale
// service-worker cache after a deploy), we reload immediately — at the Promise
// level, before React's error-boundary pipeline even gets involved.
// This eliminates the 3-5 second delay users would otherwise see.
const Loadable = (importFn) => {
  const Component = lazy(() =>
    importFn().catch(() => {
      const last = sessionStorage.getItem(RELOAD_KEY);
      const now = Date.now();
      if (!last || now - Number(last) > RELOAD_COOLDOWN_MS) {
        sessionStorage.setItem(RELOAD_KEY, String(now));
        window.location.reload();
      }
      // Return an empty module while the reload is in flight
      return { default: () => null };
    })
  );

  return (props) => (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};

export default Loadable;
